var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUserAvatarStub = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 109,
  height: 109,
  viewBox: "0 0 109 109",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 109,
  height: 109,
  fill: "#455565"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M54.7396 9C41.8293 9 31.3634 19.1669 31.3634 31.7083C31.3634 44.2498 41.8293 54.4167 54.7396 54.4167C67.6499 54.4167 78.1158 44.2498 78.1158 31.7083C78.1158 19.1669 67.6499 9 54.7396 9ZM40.7138 31.7083C40.7138 24.1835 46.9934 18.0833 54.7396 18.0833C62.4858 18.0833 68.7653 24.1835 68.7653 31.7083C68.7653 39.2332 62.4858 45.3333 54.7396 45.3333C46.9934 45.3333 40.7138 39.2332 40.7138 31.7083Z",
  fill: "#A2AAB2"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M54.74 58.9583C29.4449 58.9583 15 79.8423 15 99.8333H24.3505C24.3505 83.491 35.9127 68.0417 54.74 68.0417C73.5672 68.0417 85.1287 83.4909 85.1287 99.8333H94.4792C94.4792 79.8425 80.0353 58.9583 54.74 58.9583Z",
  fill: "#A2AAB2"
})));
export { SvgUserAvatarStub as ReactComponent };
export default __webpack_public_path__ + "assets/886208b6.svg";